import { computed, ref } from '@vue/composition-api';
import store from '@/store';
import toast from "@/utils/toast";
import { parseDateToString } from '@/auth/utils';
import userStoreModule from '../userStoreModule';

export default function useUserModal(props, emit, refFormObserver) {
  const STORE_MODULE_NAME = 'admin';

  // Register module
  if (!store.hasModule(STORE_MODULE_NAME)) {
    store.registerModule(STORE_MODULE_NAME, userStoreModule);
  }
  const webhookUrl = ref('https://api-hocphi.tingee.vn/v1/tingee/callback')
  // Use toast
  const toastification = toast();
  const refModal = ref(null);
  const refForm = ref(refFormObserver);
  const itemLocal = ref(JSON.parse(JSON.stringify(props.item)));
  const resetItemLocal = () => {
    itemLocal.value = JSON.parse(JSON.stringify(props.item));
  };
  const maxSlots = computed(() => Number(itemLocal.value.maxRoomSlots) + Number(itemLocal.value.maxBedSlots));
  const isSubmitting = ref(false);
  const resetModal = () => {
    isSubmitting.value = false;
    resetItemLocal();
  };

  const onSubmit = async bvModalEvt => {
    bvModalEvt.preventDefault();

    const success = await refForm.value.validate();
    if (!success) {
      return;
    }

    const data = {
      userId: itemLocal.value.id,
      name: itemLocal.value.name,
      phone: itemLocal.value.phone,
      email: itemLocal.value.email,
      newZaloPhone: itemLocal.value.userConfiguration.newZaloPhone,
      newZaloPassword: itemLocal.value.userConfiguration.newZaloPassword,
      newZaloSenderId: itemLocal.value.userConfiguration.newZaloSenderId,
      tingeeUsername: itemLocal.value.userConfiguration.tingeeUsername,
      tingeePassword: itemLocal.value.userConfiguration.tingeePassword,
      limitByTransaction: itemLocal.value.roles[0].limitByTransaction,
      tingeeTransactionCount: itemLocal.value.roles[0].tingeeTransactionCount,
      zaloOaMessageCount: itemLocal.value.roles[0].zaloOaMessageCount,
      ibaseTaxCode: itemLocal.value.userConfiguration.ibaseTaxCode,
      ibaseCompanyName: itemLocal.value.userConfiguration.ibaseCompanyName,
      ibaseCompanyCode: itemLocal.value.userConfiguration.ibaseCompanyCode,
      ibaseEmail: itemLocal.value.userConfiguration.ibaseEmail,
      ibaseAddressDetail: itemLocal.value.userConfiguration.ibaseAddressDetail,
      ibaseSyncInvoiceIn: itemLocal.value.userConfiguration.ibaseSyncInvoiceIn,
      ibaseSyncInvoiceOut: itemLocal.value.userConfiguration.ibaseSyncInvoiceOut,
      isReportShn: itemLocal.value.userConfiguration.isReportShn,
      levelCode: itemLocal.value.userConfiguration.levelCode,
      schoolCode: itemLocal.value.userConfiguration.schoolCode,
    };
    data.expiredIn = parseDateToString(itemLocal.value.expiredIn);

    isSubmitting.value = true;

    store
      .dispatch('admin/updateUserSubscription', data)
      .then(() => {
        isSubmitting.value = false;
      })
      .then(() => {
        refModal.value.toggle('#toggle-btn');
      })
      .then(() => {
        emit('refetch-data');
      })
      .then(() => {
        toastification.showToastUpdateSuccess();
      })
      .catch(error => {
        isSubmitting.value = false;
        toastification.showToastError(error, refForm.value);
      });
  };

  const syncTingeeVA = async () => {
    store.
      dispatch('admin/syncTingeeVA',
        {
          clientId: itemLocal.value.userConfiguration.tingeeUsername,
          secret: itemLocal.value.userConfiguration.tingeePassword,
          id: itemLocal.value.id
        }
      ).then(() => {
        emit('refetch-data');
      })
      .then(() => {
        toastification.showToastUpdateSuccess();
      })
      .catch(error => {
        isSubmitting.value = false;
        toastification.showToastError(error, refForm.value);
      });
  }

  return {
    refModal,
    refForm,
    itemLocal,
    isSubmitting,
    maxSlots,
    resetItemLocal,
    resetModal,
    onSubmit,
    syncTingeeVA,
    webhookUrl
  };
}
